import React from "react";

const DeliveryCompleteModal = () => {
  return (
    <div className="pt-2 px-4">
      해당 상품을 배송완료 처리하시겠습니까?
      <br />
      <p className="text-secondary-red mb-1">
        배송완료 이후, 수정이 불가능하오니, 택배사로부터 배송이 완료되었는지
        <br />
        최종적으로 확인 후 진행 부탁드립니다.
      </p>
      <br />
      [유의사항 안내]
      <br />
      1. 상품이 최종적으로 고객에게 배송이 완료된 것을 확인 후에 ‘배송완료’ 처리
      가능
      <br />
      2. 배송완료 상태값 설명
      <br />- 관리자가 '배송완료'를 최종적으로 처리해야만, 병원회원에게
      '배송완료' 상태로 전환되어 최종 구매확정과 같은 불량접수 신청이 종료되는
      것을 의미합니다. 택배사에게 배송완료가 확인되면, 최종 완료를 처리해 주시기
      <br />
      바랍니다.
      <div className="flex mt-8 justify-end">
        <button className="w-20 py-1 mr-2 rounded-[4px] border border-black">
          취소
        </button>
        <button className="w-20 py-1 rounded-[4px] border-primary-blue bg-primary-blue text-white border">
          배송완료
        </button>
      </div>
    </div>
  );
};

export default DeliveryCompleteModal;
